import { render, staticRenderFns } from "./MInputCentered.vue?vue&type=template&id=570d6614&"
import script from "./MInputCentered.vue?vue&type=script&lang=ts&"
export * from "./MInputCentered.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports